import { useEffect, useRef } from "react";

const SearchApiHook = (fetchData, search, prevSearch, dependencies) => {
  const isInitialRender = useRef(true);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    let delay;
    if (search !== prevSearch) {
      delay = setTimeout(() => {
        fetchData();
      }, 500);
    } else {
      fetchData();
    }

    return () => {
      clearTimeout(delay);
    };
  }, [search]);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    fetchData();
  }, dependencies);
};

export default SearchApiHook;
